module.exports = __webpack_public_path__ + "img/EXALT_INTEGRATED.8db395cc.jpg";